import script from "./InvestorKits.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestorKits.vue?vue&type=script&lang=ts&setup=true"

import "./InvestorKits.vue?vue&type=style&index=0&id=2cf06b2d&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf06b2d"]])

export default __exports__